<template>
  <div>
    <div class="title-bar clearfix">
      <div class="module pull-left">
        {{$t("delivery.title")}}
      </div>
      <div class="btn-group pull-right">
        <el-button class="sm-hidden" v-if="canImportIWAC" :plain="true" size="mini" @click="uploadDialogVisible=true">{{ $t("delivery.importIWAC") }}
          <i class="fa fa-file-excel-o"></i>
        </el-button>
        <el-button :plain="true" size="mini" @click="qrcSearchDialogVisible=true">{{ $t("delivery.qrcSearch") }}
          <i class="fa fa-qrcode"></i>
        </el-button>
        <el-button :plain="true" size="mini" @click="refresh">{{ $t("refresh") }}
          <i class="fa fa-refresh"></i>
        </el-button>
        <el-button :plain="true" size="mini" @click="searchDialogVisible=true">{{ $t("search") }}
          <i class="fa fa-search"></i>
        </el-button>
      </div>
    </div>
    <div class="data-list" v-loading="loading" element-loading-text="Loading">
      <el-table border stripe :data="deliveryInfos" size="mini" class="customer-table">
        <el-table-column :show-overflow-tooltip="true" align="center" :resizable="true" :label="this.$t('operation')">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="setOverview(scope.row)">{{ $t("delivery.overview") }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="ChannelAccount" align="center" :resizable="true" :label="this.$t('delivery.customerNumber')" width="100">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="ChannelName" align="center" :resizable="true" :label="this.$t('delivery.customerName')" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="UserType" align="center" :resizable="true" :label="this.$t('delivery.customerType')" :formatter="customerTypeFormatter" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="Office" align="center" :resizable="true" :label="this.$t('delivery.customerOffice')" width="150">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="OrderNumber" align="center" :resizable="true" :label="this.$t('delivery.orderNumber')" width="150">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="BoxNumber" align="center" :resizable="true" :label="this.$t('delivery.boxNumber')" width="190">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="EANcode" align="center" :resizable="true" :label="this.$t('delivery.eanCode')" width="150">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="ProductLongCode" align="center" :resizable="true" :label="this.$t('delivery.productLongCode')" width="100">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="ProductShortCode" align="center" :resizable="true" :label="this.$t('delivery.productShortCode')" width="100">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="AmountPerPackage" align="center" :resizable="true" :label="this.$t('delivery.amountPerPackage')" width="100">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="ProductSerials" align="center" :resizable="true" :label="this.$t('delivery.productSerials')" width="100">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="Bonus" align="center" :resizable="true" :label="this.$t('delivery.bonus')" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="QRCode1" align="center" :resizable="true" :label="this.$t('delivery.qrc1')" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="QRCode2" align="center" :resizable="true" :label="this.$t('delivery.qrc2')" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="DeliveryTime" align="center" :resizable="true" :label="this.$t('delivery.deliveryTime')" :formatter="timeFormatter" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="DeliveryScanTime" align="center" :resizable="true" :label="this.$t('delivery.boxScanTime')" :formatter="timeFormatter" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" :resizable="true" :label="this.$t('delivery.codeAuthCount')" width="150">
          <template slot-scope="scope">
            <template v-if="scope.row.ScanCount>0">
              <!--scan history popover-->
              <el-popover ref="historypop" placement="left" trigger="click" width="350" @show="listScanHistory(scope.row.QRCode1)">
                <el-table stripe :data="scanHistory" v-loading="loadingHistory" element-loading-text="Loading...">
                  <el-table-column align="center" property="ScanOrder" label="扫描次数" width="100"></el-table-column>
                  <el-table-column align="center" property="ScanTime" label="扫描时间" width="200"></el-table-column>
                </el-table>
              </el-popover>

              <el-button v-popover:historypop class="count-btn" size="mini" type="text">{{scope.row.ScanCount}}</el-button>
            </template>
            <span v-else>{{scope.row.ScanCount}}</span>

          </template>
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" align="center" :resizable="true" :label="this.$t('delivery.hasReceived')" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.ReceivedTime">已领取</span>
            <span v-else>未领取</span>
          </template>
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="ReceivedTime" align="center" :resizable="true" :label="this.$t('delivery.receivedTime')" :formatter="receivedTimeFormatter" width="180">
        </el-table-column>
      </el-table>

      <el-row class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[15, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-row>
    </div>

    <!-- search dialog -->
    <el-dialog class="search-dialog" :title="this.$t('search')" :visible.sync="searchDialogVisible" width="760px">
      <el-form class="search-form" :model="filter" :inline="true" size="small" label-width="100px">
        <el-form-item :label="this.$t('delivery.customerNumber')" size="small">
          <el-input v-model="filter.ChannelAccount"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('delivery.customerName')" size="small">
          <el-input v-model="filter.ChannelName"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('delivery.orderNumber')" size="small">
          <el-input v-model="filter.OrderNumber"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('delivery.boxNumber')" size="small">
          <el-input v-model="filter.BoxNumber"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('delivery.eanCode')" size="small">
          <el-input v-model="filter.EANcode"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('delivery.productLongCode')" size="small">
          <el-input v-model="filter.ProductLongCode"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('delivery.productShortCode')" size="small">
          <el-input v-model="filter.ProductShortCode"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('delivery.productSerials')" size="small">
          <el-input v-model="filter.ProductSerials"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('delivery.qrc1')" size="small">
          <el-input v-model="filter.QRCode1"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('delivery.qrc2')" size="small">
          <el-input v-model="filter.QRCode2"></el-input>
        </el-form-item>

        <el-form-item :label="this.$t('delivery.hasReceived')" size="small">
          <el-radio v-model="filter.hasReceived" label="true">已领取</el-radio>
          <el-radio v-model="filter.hasReceived" label="false">未领取</el-radio>
          <el-radio v-model="filter.hasReceived" label="all">所有</el-radio>
        </el-form-item><br>
        <el-form-item :label="this.$t('delivery.deliveryTime')" size="small">
          <el-date-picker v-model="filter.StartDeliveryTime" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="this.$t('to')" size="small">
          <el-date-picker v-model="filter.EndDeliveryTime" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="this.$t('delivery.boxScanTime')" size="small">
          <el-date-picker v-model="filter.StartDeliveryScanTime" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="this.$t('to')" size="small">
          <el-date-picker v-model="filter.EndDeliveryScanTime" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="this.$t('delivery.receivedTime')" size="small">
          <el-date-picker v-model="filter.StartReceivedScanTime" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="this.$t('to')" size="small">
          <el-date-picker v-model="filter.EndReceivedScanTime" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="search-footer">
        <el-button @click="searchDialogVisible = false" :plain="true" size="mini">{{this.$t('cancel')}}</el-button>
        <el-button @click="resetFilter" :plain="true" size="mini">{{this.$t('reset')}}</el-button>
        <el-button type="primary" @click="search" :plain="true" size="mini">{{this.$t('confirm')}}</el-button>
      </div>
    </el-dialog>

    <!-- upload dialog -->
    <el-dialog class="search-dialog upload-dialog" :title="this.$t('upload')" :visible.sync="uploadDialogVisible" width="480px">
      <el-alert class="upload-alert" :title="$t('delivery.ensureScanned')" type="warning">
      </el-alert>

      <el-upload ref="upload" class="iwac-upload" :action="uploadUrl" accept=".xlsx,.xls" :limit="1" :on-exceed="handleExceed" :file-list="fileList" :headers="uploadHeaders" :on-error="handleError" :on-success="handleSuccess" :auto-upload="false">

        <el-button size="small" type="primary">
          {{this.$t('delivery.clickToUpload')}}
          <i class="fa fa-upload"></i>
        </el-button>
        <div slot="tip" class="el-upload__tip">{{this.$t('delivery.selectUploadFile')}}</div>
      </el-upload>
      <a class="download-tmp" href="static/iwac.xlsx">{{$t('delivery.downloadTemp')}}</a>
      <div slot="footer" class="search-footer">
        <el-button @click="uploadDialogVisible = false" :plain="true" size="mini">{{this.$t('cancel')}}</el-button>
        <el-button type="primary" @click="upload" :plain="true" size="mini" :loading="uploading">{{this.$t('upload')}}</el-button>
      </div>
    </el-dialog>

    <!-- qrc search dialog-->
    <el-dialog class="search-dialog upload-dialog" :title="this.$t('delivery.uploadQrc')" :visible.sync="qrcSearchDialogVisible" width="30%">

      <el-upload v-if="qrcSearchType==='img'" ref="upload" class="qrc-upload" action="" :on-exceed="handleQrcExceed" :on-change="handleQrcChange" :on-remove="handleQrcRemove" accept="image/*" :limit="1" :auto-upload="false" list-type="picture-card">
        <i class="el-icon-plus"></i>
        <div slot="tip" class="el-upload__tip">{{this.$t('delivery.selectUploadQrc')}}或
          <el-button type="text" class="input-qrc" @click="qrcSearchType = 'text'">手动输入</el-button>
        </div>
      </el-upload>

      <div v-else>
        <el-input class="el-upload__tip" placeholder="请输入二维码内容" :clearable="true" v-model="qrcUrl"></el-input>
        <div style="text-align:center">
          <span class="el-upload__tip">
            手动输入二维码内容
          </span>
          或
          <el-button type="text" class="input-qrc" @click="qrcSearchType = 'img'">上传图片</el-button>
        </div>
      </div>

      <div slot="footer" class="search-footer">
        <el-button @click="qrcSearchDialogVisible = false" :plain="true" size="mini">{{this.$t('cancel')}}</el-button>
        <el-button v-if="qrcSearchType==='img'" type="primary" @click="searchImgQrc" :plain="true" size="mini">{{this.$t('query')}}</el-button>
        <el-button v-else type="primary" @click="searchUrlQrc" :plain="true" size="mini">{{this.$t('query')}}</el-button>
      </div>
    </el-dialog>

    <!-- overview dialog -->
    <el-dialog class="search-dialog" :title="this.$t('delivery.overview')" :visible.sync="showOverview" width="350px">
      <div class="overview-list">
        <div class="item">
          <span class="title">{{$t('delivery.customerNumber')}}：</span>
          <span class="item-content">{{overviewData.ChannelAccount}}</span>
        </div>
        <div class="item">
          <span class="title">{{$t('delivery.customerName')}}：</span>
          <span class="item-content">{{overviewData.ChannelName}}</span>
        </div>
        <div class="item">
          <span class="title">{{$t('delivery.customerOffice')}}：</span>
          <span class="item-content">{{overviewData.Office}}</span>
        </div>
        <div class="item">
          <span class="title">{{$t('delivery.deliveryTime')}}：</span>
          <span class="item-content">{{overviewData.DeliveryTime}}</span>
        </div>
        <div class="item">
          <span class="title">{{$t('delivery.hasReceived')}}：</span>
          <span class="item-content">{{overviewData.ReceivedTime?'已领取':'未领取'}}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import roleTypes from "../../../models/roleTypes";
import searchTypes from "../../../models/searchTypes";
import searchHistoryService from "../../../services/searchHistoryService";
import fileSaver from "file-saver";
import { mapGetters } from "vuex";
import userTypes from "../../../models/userTypes";
import qrcReader from "qrcode-reader";
import qrcodeService from "../../../services/qrcodeService";
export default {
  name: "QRCCode",
  data() {
    return {
      searchDialogVisible: false,
      uploadDialogVisible: false,
      qrcSearchDialogVisible: false,
      pageSize: 15,
      pageIndex: 1,
      totalCount: 0,
      deliveryInfos: [],
      loading: true,
      loadingHistory: false,
      uploading: false,
      showOverview: false,
      overviewData: {},
      filter: {
        hasReceived: "all"
      },
      filterOptions: [],
      fileList: [],
      uploadUrl: `${this.$axios.defaults.baseURL}api/delivery/iwac/import`,
      qrcUrl: "",
      qrcFile: {},
      qrcSearchType: "img", //text
      scanHistory: []
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.getDeliveryInfo();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getDeliveryInfo();
    },
    getDeliveryInfo() {
      this.loading = true;
      let params = {
        filter: JSON.stringify(this.filterOptions),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$axios
        .get("api/delivery", { params })
        .then(res => {
          this.totalCount = res.data.TotalCount;
          this.deliveryInfos = res.data.Data;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    search() {
      this.searchDialogVisible = false;
      this.setFilterOptions();
      searchHistoryService.setHistory(
        searchTypes.DELIVERY_HISTORY,
        this.filterOptions
      );
      this.getDeliveryInfo();
    },
    resetFilter() {
      this.pageIndex = 1;
      this.filter = {};
      this.filterOptions = [];
      searchHistoryService.removeHistory(searchTypes.DELIVERY_HISTORY);
    },
    setFilterOptions() {
      this.filterOptions = [];
      Object.keys(this.filter).forEach(k => {
        let val = this.filter[k];
        if (typeof val === "number" || val) {
          this.filterOptions.push({ name: k, value: val });
        }
      });
    },
    refresh() {
      this.resetFilter();
      this.getDeliveryInfo();
    },
    initializeFilter() {
      let his = searchHistoryService.getHistory(searchTypes.DELIVERY_HISTORY);
      if (his) {
        let keys = Object.keys(this.filter);
        his.forEach(h => {
          if (keys.includes(h.name)) {
            this.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    upload() {
      var res = this.$refs.upload.submit();
    },
    handleExceed() {
      this.$message({
        message: this.$t("delivery.uploadOneFileMsg"),
        type: "error"
      });
    },
    handleQrcExceed() {
      this.$message({
        message: this.$t("delivery.uploadOneQrcMsg"),
        type: "error"
      });
    },
    handleError(err, f, fl) {
      this.uploading = false;
      this.$message({
        message: err.message,
        type: "error"
      });
    },
    handleSuccess(resp, f, fl) {
      this.uploading = false;
      this.$message({
        message: this.$t("delivery.uploadSuccess"),
        type: "success"
      });
      this.uploadDialogVisible = false;
      this.fileList = [];
      this.refresh();
      this.showUnmatchedBoxNumber();
    },
    showUnmatchedBoxNumber() {
      this.$axios.get("api/delivery/iwac/unmatched").then(resp => {
        let res = resp.data || [];
        let length = res.length;
        let title = (length && `待匹配箱号(共${length}个)`) || "提示";
        let msg =
          (length && res.join(",\r\n")) || "全部扫描箱号均已匹配IWAC信息！";
        let type = (length && "warning") || "success";
        this.$alert(msg, title, { type });
      });
    },
    customerTypeFormatter(row, col, val) {
      return userTypes[val];
    },
    receivedTimeFormatter(row, col, val) {
      if (val) {
        return this.timeFormatter(row, col, val);
      }
      return this.$t("delivery.notReceived");
    },
    handleQrcChange(f, fl) {
      this.qrcFile = f;
      let item = this.$refs.upload.$el.querySelector(".el-upload");
      item.style.display = "none";
    },
    handleQrcRemove(f, fl) {
      this.qrcFile = {};
      let item = this.$refs.upload.$el.querySelector(".el-upload");
      item.style.display = "inline-block";
    },
    searchImgQrc() {
      if (this.qrcFile.url) {
        let reader = new qrcReader();
        reader.callback = (err, val) => {
          if (!err) {
            let qrcCode = qrcodeService.getQRCode(val.result);
            this.searchQrc(qrcCode);
          } else {
            this.$message({
              message: this.$t("delivery.resolveQrcodeFail"),
              type: "error"
            });
          }
        };
        reader.decode(this.qrcFile.url);
      }
    },
    searchUrlQrc() {
      let qrcCode = qrcodeService.getQRCode(this.qrcUrl);
      this.searchQrc(qrcCode);
    },
    searchQrc(qrcCode) {
      this.$axios
        .get(`api/qrc/check/${qrcCode}`)
        .then(resp => {
          let res = resp.data;
          if (!res) {
            this.$message({
              message: this.$t("delivery.notExistQrcode"),
              type: "error"
            });
            return;
          }
          this.resetFilter();
          if (res === 1) {
            this.filter.QRCode1 = qrcCode;
          } else if (res === 2) {
            this.filter.QRCode2 = qrcCode;
          }
          this.search();
          this.qrcSearchDialogVisible = false;
        })
        .catch(e => {
          this.$message({
            message: this.$t("delivery.notExistQrcode"),
            type: "error"
          });
        });
    },
    listScanHistory(code) {
      this.scanHistory = [];
      this.loadingHistory = true;
      this.$axios.get(`api/delivery/scanhistory/${code}`).then(resp => {
        if (resp.data) {
          this.scanHistory = resp.data;
          this.loadingHistory = false;
        }
      });
    },
    setOverview(data) {
      this.showOverview = true;
      this.overviewData = data;
    }
  },
  computed: {
    ...mapGetters(["roles", "permissions", "token"]),
    canImportIWAC() {
      return this.roles.includes(roleTypes.Administrator);
    },
    uploadHeaders() {
      return {
        Authorization: `bearer ${this.token}`
      };
    }
  },
  created() {
    this.initializeFilter();
    this.getDeliveryInfo();
  }
};
</script>

<style lang="scss" scoped>
.iwac-upload,
.qrc-upload {
  text-align: center;
}

.no-wrap {
  .cell {
    white-space: nowrap;
    word-break: keep-all;
    width: 100%;
  }
}

.upload-alert {
  position: relative;
  top: -20px;
}

.upload-dialog .el-dialog {
  background: #eee;
}

.qrc-img {
  width: 120px;
  height: 120px;
  display: block;
}

.download-tmp {
  position: absolute;
  top: 50%;
  right: 20%;
  text-decoration: underline;
  color: #95c44a;
  &:hover {
    color: darken($color: #95c44a, $amount: 5);
  }
}

.count-btn {
  padding: 0;
}

.overview-list {
  padding-left: 50px;
  margin-top: -10px;
  .item {
    padding-bottom: 8px;
    .title {
      color: rgba($color: #000000, $alpha: 0.85);
    }
    .item-content {
      color: rgba($color: #000000, $alpha: 0.65);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/application/Delivery/Delivery.vue